<div class="agenx-background-app agenx-all-viewport">
  <router-outlet></router-outlet>
</div>